import { ViewModel, View } from "binder"
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";

export class WeekSelectorMultiSelectorViewModel extends MultiSelectorBaseViewModel<DayOfWeek> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<DayOfWeek[]> {
        let weekDays = [
            { "Id": "1", "Day": "شنبه" },
            { "Id": "2", "Day": "یک‌شنبه" },
            { "Id": "3", "Day": "دوشنبه" },
            { "Id": "4", "Day": "سه‌شنبه" },
            { "Id": "5", "Day": "چهارشنبه" },
            { "Id": "6", "Day": "پنج‌شنبه" },
            { "Id": "7", "Day": "جمعه" }
        ];
        return weekDays.map(x => {
            let d = new DayOfWeek(this);
            d.id = x.Id;
            d.title = x.Day;
            return d;
        });
    }
}

export class WeekSelectorViewModel extends SelectorBaseViewModel<DayOfWeek> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<DayOfWeek[]> {
        let weekDays = [
            { "Id": "1", "Day": "شنبه" },
            { "Id": "2", "Day": "یک‌شنبه" },
            { "Id": "3", "Day": "دوشنبه" },
            { "Id": "4", "Day": "سه‌شنبه" },
            { "Id": "5", "Day": "چهارشنبه" },
            { "Id": "6", "Day": "پنج‌شنبه" },
            { "Id": "7", "Day": "جمعه" }
        ];
        return weekDays.map(x => {
            let d = new DayOfWeek(this);
            d.id = x.Id;
            d.title = x.Day;
            return d;
        });
    }
}

export class DayOfWeek extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}
